import { Header, AccordionTriggerProps } from '@radix-ui/react-accordion';
import { forwardRef, Ref } from 'react';
import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';
import { colors } from 'ui/theme/colors';
import { StyledTrigger } from './Accordion.styled';

type Props = {
  arrowHeight?: number;
  arrowWidth?: number;
  arrowColor?: string;
} & AccordionTriggerProps;

export const AccordionHeader = forwardRef(
  (
    {
      children,
      arrowHeight = 24,
      arrowWidth = 24,
      arrowColor = colors.secondaryText,
      ...props
    }: Props,
    forwardedRef: Ref<HTMLButtonElement>,
  ) => (
    <Header asChild>
      <StyledTrigger ref={forwardedRef} {...props}>
        {children}
        <ChevronRightSmall
          // data-id is used as a css selector
          data-id="chevron"
          data-test="chevron"
          width={arrowWidth}
          height={arrowHeight}
          color={arrowColor}
        />
      </StyledTrigger>
    </Header>
  ),
);
